import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, Image, Modal, Dimensions, PixelRatio } from 'react-native'
import MenuBar from '../../icons/MenuBar'
import Colours from '../../utils/Colours'
import NotificationBellIcon from '../../icons/NotificationBellIcon'
import NotificationScreen from '../notifications/NotificationScreen'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import { TouchableOpacity } from 'react-native'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import AsyncStorage from '@react-native-async-storage/async-storage'
import ProfileScreen from '../profileScreen/ProfileScreen'
import useAuth from '../../hooks/useAuth'

import * as SecureStore from 'expo-secure-store';


// // Function for dynamic sizing (width, height, borderRadius)
// const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};


const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

const TopHeader = ({ headerText }) => {

  const [notificationCount, setNotificationCount] = useState(0)
  const [invitesDataLenght, setInvitesDataLength] = useState(0)
  const [hasViewedNotifications, setHasViewedNotifications] = useState(null);
  const [showNotificationScreen, setShowNotificationScreen] = useState(false)
  const [showUserProfilePage, setShowUserProfilePage] = useState(false)
  const [notificationData, setNotificationData] = useState([])
  const [tableInvites, setTableInvites] = useState([])

  const axiosPrivate = useAxiosPrivate()

  const { username } = useAuth()


  useEffect(() => {
    // checkNotificationStatus()
    // getTableInvites()
  }, [])

  useEffect(() => {
    //console.log('Here then')
    getNotificationData()
  }, [])

  const unseenNotifications = notificationData.filter(
    (n) => n.seen === false
  ).length;



  const handleNotifications = async () => {

    setShowNotificationScreen(true)

  };


  const handleOpenUserProfile = async () => {
    setShowUserProfilePage(true)
  }


  // const getTableInvites = async () => {
  //   try {
  //     const response = await axiosPrivate.get('/invites/tableInvites');

  //     if (response.status === 200 || response.status === 201) {
  //       setTableInvites(response.data.invites);

  //       //  const hasViewed = await AsyncStorage.getItem(`hasViewedNotifications_${username}`);

  //       // const seenInvites = await SecureStore.getItemAsync('hasSeenInvites');
  //       // const seenCelebrate = await SecureStore.getItemAsync('hasSeenCelebratories')

  //       // if (response.data.invites.length > 0) {
  //       //   if (hasViewed === 'true') {
  //       //     setNotificationCount(1); // show badge
  //       //     // await AsyncStorage.setItem(`hasViewedNotifications_${username}`, 'false');
  //       //   }
  //       // }

  //       setInvitesDataLength(response.data.invites.length)

  //       // if (response.data.invites.length > 0 && seenInvites === 'false' && seenCelebrate === 'false') {
  //       //   setNotificationCount(1); // show badge
  //       // }
  //     }
  //   } catch (error) {
  //     if (error.response?.status === 404) {
  //       setTableInvites([]);
  //     } else {
  //       //console.log("TableInviteERROR:", error.response?.status, error.response?.data || error.message);
  //     }
  //   }
  // };

  const getNotificationData = async () => {

    try {

      const response = await axiosPrivate.get('/getAllNotifications/getAllNotifications');

      if (response.status === 200 || response.status === 201) {

        //console.log('notificationsDataXTE', response.data.notifications)
        // setNotificationData(response.data.notifications)

        // default to [] if null/undefined
        setNotificationData(response.data.notifications ?? []);
      }


    } catch (error) {
      //console.log('Error Notification DatA', error)
    }

  }



  return (

    <View style={styles.topHeaderContainer}>
      <TouchableOpacity onPress={handleOpenUserProfile}>
        <MenuBar color={Colours.DARKGRAY} />
      </TouchableOpacity>

      <Text style={{ fontSize: 20, color: Colours.DARKGRAY, fontFamily: 'Sen-Bold' }}>
        {headerText}
      </Text>

      <TouchableOpacity
        style={styles.notificationContainer}
        onPress={handleNotifications}
      >
        <NotificationBellIcon color={Colours.DARKGRAY} height={25} width={25} />

        {/* {notificationCount > 0 && (
          <View style={styles.notificationDot} /> 
        )} */}
        {unseenNotifications > 0 && (
          <View style={styles.notificationDot} />
        )}
      </TouchableOpacity>

      <Modal
        animationType='slide'
        visible={showNotificationScreen}
        onRequestClose={() => {
          setShowNotificationScreen(false)
        }}
      >
        <TopHeaderComponent headerText={'Notifications'} hideScreen={() => {
          setShowNotificationScreen(false)
        }} />
        <NotificationScreen
          tableInvites={tableInvites}
          getNotificationData={getNotificationData}
          setTableInvites={setTableInvites}
          setNotificationCount={setNotificationCount}

          notificationData={notificationData}
        />
      </Modal>

      <Modal
        animationType='slide'
        visible={showUserProfilePage}
        onRequestClose={() => setShowUserProfilePage(false)}
      >
        <TopHeaderComponent headerText={'My Profile'} hideScreen={() => setShowUserProfilePage(false)} />
        <ProfileScreen
        // hideProfileScreen={() => setShowUserProfilePage(false)}
        />
      </Modal>
    </View>
  )
}

const styles = StyleSheet.create({
  topHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    //   backgroundColor: "#12ff34",
    alignItems: "center",
    padding: 15,
    paddingTop: 20,
  },
  notificationDot: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: dynamicSize(10),
    height: dynamicSize(10),
    borderRadius: dynamicSize(5),
    backgroundColor: 'red',
  },

  notificationContainer: {
    position: 'relative',
  },

  notificationBadge: {
    position: 'absolute',
    top: -5,
    right: -5,
    backgroundColor: 'red',
    borderRadius: 10,
    // width: 20,
    minWidth: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  largeBadge: {
    minWidth: 30, // Expands width for larger counts like "99+"
  },
  badgeText: {
    color: 'white',
    fontSize: 12,
    fontFamily: 'Sen-Bold',
  },
})

export default TopHeader